import React from 'react';
import { NumberInputRow } from '@/components/form/NumberInputRow';
import { AnimatedFormError } from '@/components/form/AnimatedFormError';


interface Props {
  timeCreditMinutesProps?: Record<string, unknown>;
  timeCreditMinutesError?: React.ReactNode;
}

export const CreditExtraTimeSection: React.FC<Props> = ({
  timeCreditMinutesProps,
  timeCreditMinutesError,
}) => {
  return (
    <div>
      <NumberInputRow
          id="credit-extra-time-minutes"
          label="Credit Time"
          description="Specifies the number of minutes' worth of pay that is calculated and added as a dynamic hourly bonus for every hour worked within the overnight premium window."
          unit="mins"
          inputProps={timeCreditMinutesProps ?? {}}
          errorElement={<AnimatedFormError>{timeCreditMinutesError}</AnimatedFormError>}
          inputWidth="half"
        />
    </div>
  );
};
